export const openLinkInSameTab = (url: string) => {
  window.open(url, '_self');
};
